"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SocialBannerType=void 0;var i;(function(e){e.Acquisition="acquisition",e.Request="request"})(i||(exports.SocialBannerType=i={}));
//# sourceMappingURL=SocialBannerType.js.map
